import stateSettings from '@state/settings';
import { ObjectFit } from '@src/interfaces/nodes';
import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@src/styles';
import { useState } from 'react';
import { ColorBox, Divider, IconRow, InfoColumn, StylelessButton, Title, TopBarBox, } from '@src/editor/Elements/TopBar/shared/_styles';
import { changeProperty } from '@src/actions';
import StateMutator from '@src/editor/Elements/TopBar/shared/StateMutator';
import ZIndexMutator from '@src/editor/Elements/TopBar/shared/ZIndexMutator';
import { getSelectedNode } from '@src/utils';
const ImageBoxWrapper = styled.div `
  position: relative;
`;
const ImageDropdown = styled.div `
  position: absolute;
  padding: 24px;
  top: 40px;
  width: 500px;
  height: 400px;
  overflow: scroll;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  right: 0;
  z-index: 999999;
  background: #f8f8f8;
`;
const Image = styled.img `
  object-fit: contain;
  width: 200px;
  height: 200px;
`;
const ImageGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, 200px);
  grid-gap: 24px;
`;
const BorderBox = styled(StylelessButton) `
  border: ${({ border }) => border.style};
  border-radius: ${({ border }) => border.radius};
  background: ${({ selected }) => (selected ? Colors.accent : 'white')};
  margin-right: 4px;
  width: 20px;
  height: 20px;
`;
const BoxShadowBox = styled(StylelessButton) `
  box-shadow: ${({ boxShadow }) => boxShadow.value};
  background: ${({ selected }) => (selected ? Colors.accent : 'white')};
  margin-right: 4px;
  width: 20px;
  height: 20px;
`;
const changeBackground = (colorId) => () => {
    changeProperty('backgroundImageUrl', null);
    changeProperty('backgroundColorId', colorId);
};
const changeBackgroundToImage = (image) => () => {
    changeProperty('backgroundColorId', null);
    changeProperty('backgroundImageUrl', image.url);
};
const changeObjectFit = (objectFit) => () => {
    changeProperty('backgroundImagePosition', objectFit);
};
const changeBorder = (border) => () => {
    changeProperty('border', border.id);
};
const changeBoxShadow = (boxShadow) => () => {
    changeProperty('boxShadow', boxShadow.id);
};
const ImageBox = () => {
    const [open, updateOpen] = useState(false);
    return (React.createElement(ImageBoxWrapper, null,
        React.createElement("div", { onClick: () => updateOpen(!open) }, "img"),
        open && (React.createElement(ImageDropdown, null,
            React.createElement("div", null,
                React.createElement(Title, null, "Background Image"),
                React.createElement(IconRow, null,
                    React.createElement(StylelessButton, { onClick: changeObjectFit(ObjectFit.cover) }, "cover/"),
                    React.createElement(StylelessButton, { onClick: changeObjectFit(ObjectFit.contain) }, "contain/"),
                    React.createElement(StylelessButton, { onClick: changeObjectFit(ObjectFit.fill) }, "fill"))),
            React.createElement(ImageGrid, null, stateSettings.images.map((img) => (React.createElement(Image, { src: img.url, key: img.id, onClick: changeBackgroundToImage(img) }))))))));
};
const BoxMutators = () => {
    const component = getSelectedNode();
    return (React.createElement(TopBarBox, null,
        React.createElement(ZIndexMutator, null),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Background"),
            React.createElement(IconRow, null,
                React.createElement(ColorBox, { selected: component.backgroundColorId === null, color: "#ffffff", onClick: changeBackground(null) },
                    React.createElement("i", { className: "material-icons" }, "clear")),
                stateSettings.colors.map((color) => (React.createElement(ColorBox, { key: color.id, selected: component.backgroundColorId === color.id, title: color.name, color: color.hex, onClick: changeBackground(color.id) }))),
                React.createElement(ImageBox, null))),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Borders"),
            React.createElement(IconRow, null,
                React.createElement(BorderBox, { title: "None", border: { style: 'none', radius: 'none' }, selected: component.border === null, onClick: changeBorder(null) }),
                stateSettings.border.map((border) => (React.createElement(BorderBox, { key: border.id, selected: component.border === border.id, border: border, onClick: changeBorder(border) }))))),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Box-Shadow"),
            React.createElement(IconRow, null,
                React.createElement(BoxShadowBox, { title: "None", boxShadow: { value: 'none' }, selected: component.boxShadow === null, onClick: changeBoxShadow(null) }),
                stateSettings.boxShadow.map((boxShadow) => (React.createElement(BoxShadowBox, { key: boxShadow.id, selected: component.boxShadow === boxShadow.id, boxShadow: boxShadow, onClick: changeBoxShadow(boxShadow) }))))),
        React.createElement(StateMutator, null)));
};
export default BoxMutators;
